import i18n from '@/i18n'
import store from '@/store'
import router from '@/router/index'
import session from '@/services/authentication/session'
import _ from 'lodash'
import Notify from 'quasar/src/plugins/Notify.js';

let errorInterceptor = {
    type: 'response',

    process(response) {
        return response
    },

    async exception(error) {
        if (
            error.message === 'Network Error' ||
            error.response.status === 500
        ) {
            // notify({
            //     color: 'negative',
            //     message: i18n('notify.error_occurred', { message: 'Network Error' }),
            // })
            console.log(
                error.response?.data.message ||
                    error.response?.statusText ||
                    error
            )
            store.commit('loading/clearLoadings')
            router.push({ name: 'Error' })
        }

        if (error.response) {
            if ([404, 403, 401, 400].indexOf(error.response.status) !== -1) {
                // REMOVE SESSION IF REFRESH TOKEN FAILS
                if (_.endsWith(error.request?.responseURL, 'refresh-token')) {
                    await session.removeSession()
                    router.push('/login')
                }
                if (error.response.data.status === 'validationError') {
                    let text = ''
                    for (const err of error.response.data.errors) {
                        text += i18n.t(err.message, {
                            value: err.value,
                        })
                        text += ';\n'
                    }
                    store.commit('dialog/showDialog', text)
                }
                if (error.response.data.status === 'UnauthorizedError') {
                    store.commit(
                        'dialog/showDialog',
                        error.response.data.message
                    )
                } else {
                    if (error.response.data?.message) {
                        let errorMessage = i18n.t(error.response.data.message)
                        if (errorMessage !== error.response.errors.message) {
                            Notify.create({
                                type: 'negative',
                                message: i18n.t(error.response.data.errors),
                            })
                        }
                    }
                }

                console.log(
                    error.response?.data.message ||
                        error.response?.statusText ||
                        error
                )
                store.commit('loading/clearLoadings')
            }
        }

        return Promise.reject(error)
    },
}

export { errorInterceptor }
